import React from 'react';
import { 
  Container, 
  Typography, 
  Box, 
  Fade 
} from '@mui/material';
import { 
  EventAvailable as ReservationIcon
} from '@mui/icons-material';
import { MovilidadElectricaProvider } from '../../context/MovilidadElectricaContext';
import ReservasParqueaderosList from '../../components/MovilidadElectrica/ReservasParqueaderosList';

const ReservasParqueaderosContent = () => {
  return (
    <Box>
      <ReservasParqueaderosList />
    </Box>
  );
};

const ReservasParqueaderos = () => {
  return (
    <Fade in timeout={800}>
      <Container 
        maxWidth={false} 
        sx={{ 
          py: { xs: 1.5, sm: 2, md: 3 },
          px: { xs: 2, sm: 3, md: 4, lg: 6 },
          maxWidth: '1600px',
          mx: 'auto',
          width: '100%'
        }}
      >
        {/* Header responsive optimizado */}
        <Box sx={{ 
          display: 'flex', 
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: { xs: 'flex-start', sm: 'center' }, 
          gap: { xs: 1, sm: 2 }, 
          mb: { xs: 2, sm: 3, md: 4 },
          background: 'linear-gradient(135deg, #002642 0%, #00577A 100%)',
          color: '#FFFFFF',
          px: { xs: 1.5, sm: 3, md: 4 },
          py: { xs: 1.5, sm: 2.5, md: 3 },
          borderRadius: { xs: 2, sm: 3 },
          boxShadow: { 
            xs: '0 4px 12px rgba(0, 38, 66, 0.15)', 
            sm: '0 8px 32px rgba(0, 38, 66, 0.12)' 
          }
        }}>
          {/* Icono y título en una fila en móvil */}
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: { xs: 1, sm: 2 },
            width: { xs: '100%', sm: 'auto' }
          }}>
            <Box
              sx={{
                p: { xs: 0.75, sm: 1.25 },
                borderRadius: { xs: 1.5, sm: 2 },
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                display: 'flex',
                alignItems: 'center',
                flexShrink: 0
              }}
            >
              <ReservationIcon sx={{ 
                fontSize: { xs: '1.25rem', sm: '1.75rem', md: '2rem' },
                color: '#DB9600'
              }} />
            </Box>
            
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography 
                variant="h4"
                sx={{
                  fontWeight: 700,
                  color: '#FFFFFF',
                  fontSize: { xs: '1.1rem', sm: '1.5rem', md: '2rem', lg: '2.25rem' },
                  mb: { xs: 0, sm: 0.25 },
                  lineHeight: { xs: 1.2, sm: 1.1 },
                  textShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                  wordBreak: { xs: 'break-word', sm: 'normal' }
                }}
              >
                {/* Texto adaptativo según pantalla */}
                <Box component="span" sx={{ display: { xs: 'none', md: 'inline' } }}>
                  Reservas de Parqueaderos
                </Box>
                <Box component="span" sx={{ display: { xs: 'none', sm: 'inline', md: 'none' } }}>
                  Reservas Parqueaderos
                </Box>
                <Box component="span" sx={{ display: { xs: 'inline', sm: 'none' } }}>
                  Reservas
                </Box>
              </Typography>
            </Box>
          </Box>
          
          {/* Descripción separada en móvil */}
          <Box sx={{ 
            width: '100%',
            pl: { xs: 0, sm: 0 },
            mt: { xs: 0.5, sm: 0 }
          }}>
            <Typography
              variant="body1"
              sx={{
                color: 'rgba(255, 255, 255, 0.85)',
                fontSize: { xs: '0.75rem', sm: '0.9rem', md: '1rem' },
                lineHeight: { xs: 1.3, sm: 1.4 },
                maxWidth: { xs: '100%', sm: '400px', md: 'none' }
              }}
            >
              {/* Descripción adaptativa */}
              <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>
                Gestión de reservas de espacios de carga eléctrica
              </Box>
              <Box component="span" sx={{ display: { xs: 'inline', sm: 'none' } }}>
                Gestión de espacios de carga
              </Box>
            </Typography>
          </Box>
        </Box>

        {/* Content */}
        <MovilidadElectricaProvider>
          <ReservasParqueaderosContent />
        </MovilidadElectricaProvider>
      </Container>
    </Fade>
  );
};

export default ReservasParqueaderos;
